import { createContext } from 'react';
import { AccountType, dataStructure } from '@goldwasserexchange/oblis-frontend-utils';

export const mobileSelectedAccountTypeContext = createContext<[AccountType, React.Dispatch<React.SetStateAction<AccountType>>]>([dataStructure.accountType.list[0], () => { throw new Error('cannot set the mobileSelectedAccountTypeContext outside of a provider'); }]);
